import { JSX } from 'react';
import { AccountAndBillingPage as SharedAccountAndBillingPage } from 'shared/accountAndBilling';
import usePartnerBillingHostProps from './usePartnerBillingHostProps';

export default function AccountBillingPage(): JSX.Element {
  const props = usePartnerBillingHostProps();

  return <SharedAccountAndBillingPage {...props} />;
}
